import { combineEpics } from 'redux-observable';
// ---- external imports ----

import loadGameLoadingEpic from './loadGameLoadingEpic';
import newGameLoadingEpic from './newGameLoadingEpic';
import nextTurnLoadingEpic from './nextTurnLoadingEpic';
import reLoadingCheckpointLoadingEpic from './reLoadingCheckpointLoadingEpic';

export default combineEpics(
	loadGameLoadingEpic,
	newGameLoadingEpic,
	nextTurnLoadingEpic,
	reLoadingCheckpointLoadingEpic
);
